export function jsonError(jsonStr) {
  try {
    JSON.parse(jsonStr);
    return false;
  } catch (e) {
    return e;
  }
}



// WEBPACK FOOTER //
// ./src/utils/jsonUtils.js